import styled from 'styled-components';
import { ReactSVG } from 'react-svg';
import { mediaBreakpointUp, mediaBreakpointDown } from '../../styles/grid';
import Link from '../Link';

export const Container = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  color: ${({ theme }) => theme.configs.footerBox.fontColor};
  background-color: ${({ theme }) => theme.configs.widget.bgColor};
  ${mediaBreakpointUp.md} {
    justify-content: space-between;
  }
`;

const SubContainer = styled.div`
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    font-size: ${({ theme }) =>
      theme.configs.fonts.fontSize.progressIndicator}px;
    line-height: 14px;
    text-decoration: none;
    color: currentColor;
  }
  ${mediaBreakpointUp.md} {
    flex-basis: auto;
  }
`;

export const LinksContainer = styled(SubContainer)`
  flex-direction: column;
  > div {
    margin: 6px;
  }
  ${mediaBreakpointUp.md} {
    justify-content: flex-end;
    flex-direction: row;
    > div {
      margin: 0px;
    }
  }
`;

export const PoweredByContainer = styled(SubContainer)`
  margin-top: 16px;
  order: 2;
  flex-grow: 1;

  ${mediaBreakpointUp.md} {
    justify-content: flex-start;
    order: 0;
    margin-top: 0;
  }
`;

export const PoweredBy = styled.div`
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
  line-height: 17px;
  font-weight: 700;
`;

export const LogoWrapper = styled.div`
  margin-left: 16px;
  display: flex;

  svg {
    width: 150px;
    height: auto;
  }
`;

export const Icons = styled.div`
  svg {
    margin: 0 4px;
    fill: currentColor;
  }
`;

export const TermAndCond = styled.span`
  margin: 0 16px;
`;

export const ContactSupportIconWrapper = styled(Link)`
  margin-left: 25px;

  ${mediaBreakpointDown.sm} {
    order: -1;
    margin-left: 0;
  }

  * {
    fill: ${({ theme }) => theme.configs.CTAButton.bgColor};
  }

  g {
    stroke: ${({ theme }) => theme.configs.CTAButton.fontColor};
  }
`;
